<template>
  <div id="periode-form">
    <!-- Nama Periode -->
    <v-list-item two-line class="pa-0">
      <v-list-item-content class="pa-0">
        <v-list-item-title class="font-weight-bold pb-2">Nama Periode *</v-list-item-title>
        <v-text-field
          id="periode_name"
          ref="name"
          placeholder="Nama Periode"
          :rules="nameRules"
          v-model="periode.name"
          outlined
        />
      </v-list-item-content>
    </v-list-item>

    <!-- Deskripsi -->
    <v-list-item two-line class="pa-0">
      <v-list-item-content class="pa-0">
        <v-list-item-title class="font-weight-bold pb-2">Deskripsi</v-list-item-title>
        <v-textarea
          id="periode_deskripsi"
          ref="description"
          placeholder="Deskripsi Periode"
          :rules="descriptionRules"
          v-model="periode.description"
          outlined
        />
      </v-list-item-content>
    </v-list-item>

    <!-- Dates -->
    <v-list-item class="pa-0">
      <v-row>
        <!-- Start -->
        <v-col cols="6">
          <v-list-item two-line class="py-0 px-1">
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold pb-2">Waktu Mulai *</v-list-item-title>
              <v-menu v-model="menuStart" :close-on-content-click="false" transition="slide-y-reverse-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    id="periode_start_date"
                    v-model="periode.start_date"
                    append-icon="mdi-calendar"
                    placeholder="Tanggal"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    readonly
                  />
                </template>
                <v-date-picker v-model="periode.start_date" no-title scrollable @change="menuStart = false" />
              </v-menu>
            </v-list-item-content>
          </v-list-item>
        </v-col>

        <!-- End -->
        <v-col cols="6">
          <v-list-item two-line class="py-0 px-1">
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold pb-2">Waktu Berakhir *</v-list-item-title>
              <v-menu v-model="menuEnd" :close-on-content-click="false" transition="slide-y-reverse-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    id="periode_end_date"
                    v-model="periode.end_date"
                    append-icon="mdi-calendar"
                    placeholder="Tanggal"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    readonly
                  />
                </template>
                <v-date-picker v-model="periode.end_date" no-title scrollable @change="menuEnd = false" />
              </v-menu>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
    </v-list-item>

    <!-- Status -->
    <v-list-item two-line>
      <v-list-item-content class="pa-0">
        <v-list-item-title class="font-weight-bold pb-2">Status</v-list-item-title>
        <v-checkbox
          id="periode_status"
          label="Aktif"
          v-model="periode.is_active"
          class="pa-2 ma-0 d-inline-flex"
        />
      </v-list-item-content>
    </v-list-item>

    <!-- Actions -->
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn id="periode_simpan" color="blew" @click="submit" depressed dark>Simpan</v-btn>
    </v-card-actions>

    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>

<script>
import Spinner from "@/modules/global/components/plugins/Spinner";
import AmbisMeterService from "@/modules/ambis_meter/services/ambis_meter.js";

export default {
  name: "periode-editform",
  components: { "app-spinner": Spinner },

  data() {
    return {
      isLoading: false,
      menuStart: false,
      menuEnd: false,
      nameRules: [(v) => (v || "").length <= 100 || "Maksimal 100 karakter"],
      descriptionRules: [(v) => (v || "").length <= 255 || "Maksimal 255 karakter"],
      periode: {
        id: 0,
        name: "",
        description: "",
        start_date: "", // always YYYY-MM-DD
        end_date: "",   // always YYYY-MM-DD
        is_active: false
      }
    };
  },

  mounted() {
    if (this.$store.state.ambismeter.id > 0) {
      // hydrate from store
      const stored = this.$store.state.ambismeter;
      this.periode = {
        ...stored,
        start_date: stored.start_date || this.today(),
        end_date: stored.end_date || this.today()
      };
    } else {
      this.periode.start_date = this.today();
      this.periode.end_date = this.today();
    }
  },

  methods: {
    today() {
      return new Date().toISOString().substring(0, 10);
    },

    formatForBackend(date) {
      if (!date) return "";
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    },

    submit() {
      if (!this.validateForm()) {
        window.scrollTo(0, 0);
        return;
      }

      const params = {
        ...this.periode,
        start_date: this.formatForBackend(this.periode.start_date),
        end_date: this.formatForBackend(this.periode.end_date)
      };

      this.isLoading = true;
      AmbisMeterService.updatePeriode(this.$route.query.id, params, (result) => {
        this.isLoading = false;
        if (result.success && result.data && result.data.id) {
          this.storePeriodeAndComplete(result.data);
        } else {
          this.$store.commit("showAlert", {
            message: "Gagal menyimpan periode!",
            type: "error"
          });
        }
      });
    },

    storePeriodeAndComplete(data) {
      // save into store as-is
      this.$store.commit("periode_init", data);
      this.$store.commit("showAlert", {
        message: `Periode telah berhasil disimpan!`,
        type: "success"
      });
    },

    validateForm() {
      let errors = false;

      if (!this.periode.name) {
        this.$store.commit("showAlert", {
          message: "Nama Periode!",
          submessage: "Nama wajib diisi!",
          type: "error"
        });
        errors = true;
      } else if (!this.periode.start_date) {
        this.$store.commit("showAlert", {
          message: "Waktu Mulai!",
          submessage: "Waktu Mulai wajib diisi!",
          type: "error"
        });
        errors = true;
      } else if (!this.periode.end_date) {
        this.$store.commit("showAlert", {
          message: "Waktu Berakhir!",
          submessage: "Waktu Berakhir wajib diisi!",
          type: "error"
        });
        errors = true;
      } else if (!this.$refs.name.validate()) {
        this.$store.commit("showAlert", {
          message: "Nama melebihi maksimal karakter!",
          type: "error"
        });
        errors = true;
      } else if (!this.$refs.description.validate()) {
        this.$store.commit("showAlert", {
          message: "Deskripsi melebihi maksimal karakter!",
          type: "error"
        });
        errors = true;
      }

      return !errors;
    }
  }
};
</script>



// WEBPACK FOOTER //
// PeriodeEditForm.vue?2ef77205